<template>
  <v-alert v-model="alert" color="primary" variant="tonal" class="mx-3 my-3">
    <div class="d-flex">
      <v-icon icon="mdi-rocket-launch-outline" class="me-2" />
      <span>Notifikasi Tugas</span>
      <v-spacer></v-spacer>
      <v-icon icon="mdi-close my-auto" size="x-small" @click="alert = false" />
    </div>
    <div class="text-black text-caption my-2">
      Ada tugas yang wajib Anda kerjakan satu minggu ke depan
    </div>
    <v-card
      v-for="t in tugas"
      variant="outlined"
      color="black"
      class="pa-2 mb-2"
      @click="selectTugas(t)"
    >
      <div class="d-flex justify-space-between">
        <span class="text-caption">
          {{ t.title }}
        </span>
        <v-icon
          icon="mdi-arrow-right-bold-circle-outline"
          size="x-small"
          class="my-auto"
        />
      </div>
    </v-card>
  </v-alert>
  <UploadAssignmentDialog
    v-model="uploadAssignmentDialog"
    :uploadAssignmentDialog="uploadAssignmentDialog"
    :selectedTugas="selectedTugas"
    :isFromNoftification="true"
    :getEnd="formatDate(tugas[0]?.end)"
    @closeUploadAssignmentDialog="uploadAssignmentDialog = false"
  />
</template>
<script>
import UploadAssignmentDialog from "./UploadAssignmentDialog.vue";

export default {
  props: {
    tugas: { type: Array, required: true },
  },
  components: { UploadAssignmentDialog },
  data() {
    return {
      alert: true,
      uploadAssignmentDialog: false,
      selectedTugas: {},
      // getEnd: null,
    };
  },
  methods: {
    getEnd(item) {
      return (
        item.end ||
        (item.extendedProps && item.extendedProps.end) ||
        item.endStr ||
        item.due_date ||
        item.dueDate ||
        null
      );
    },
    formatDate(date) {
      if (!date) return "-";
      const d = new Date(date);
      if (isNaN(d)) return String(date);
      return d.toLocaleDateString("id-ID", {
        day: "2-digit",
        month: "long",
        year: "numeric",
      });
    },
    selectTugas(value) {
      this.uploadAssignmentDialog = true;
      this.selectedTugas = {
        extendedProps: value,
      };
    },
  },
};
</script>
